import { render, staticRenderFns } from "./addDate.vue?vue&type=template&id=4da48456&scoped=true&"
import script from "./addDate.vue?vue&type=script&lang=js&"
export * from "./addDate.vue?vue&type=script&lang=js&"
import style0 from "./addDate.vue?vue&type=style&index=0&id=4da48456&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "4da48456",
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("D:\\workspace\\uat\\platform-uat\\Platform-foundation-pc\\node_modules\\vue-hot-reload-api\\dist\\index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('4da48456')) {
      api.createRecord('4da48456', component.options)
    } else {
      api.reload('4da48456', component.options)
    }
    module.hot.accept("./addDate.vue?vue&type=template&id=4da48456&scoped=true&", function () {
      api.rerender('4da48456', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/components/System/dictionary/addDate.vue"
export default component.exports